import React, { useState, useEffect, useLayoutEffect } from 'react';
import axios from 'axios';
// @mui
import { Grid, Button, Container, Stack, Pagination } from '@mui/material';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

const DivTable = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
});

const DivTableBody = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

const DivTableRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '1rem 0',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  borderBottom: '1px solid #ddd',
});

const DivTableCell = styled('div')({
  display: 'flex',
});

const DivTableTitle = styled('h4')({
  fontWeight: 500,
  marginBottom: '5px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

const DivTableContent = styled('p')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

// ----------------------------------------------------------------------

export default function MainViewPostList({ data }) {
  const [boardList, setBoardList] = useState([]);

  // ----------------------------------------------------------------------

  // ----------------------------------------------------------------------

  const fetchData = async (jsonData) => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SERVER_URL}/boards/list`,
        method: 'post',
        data: jsonData,
      });

      // console.log("data",response.data[0][0]);
      const newBoardList = [];

      for (let i = 0; i < response.data[0].length; i += 1) {
        newBoardList.push({
          id: response.data[0][i].content_id,
          title: response.data[0][i].content_title,
          content: response.data[0][i].content_message.replace(/(<([^>]+)>)/gi, ''),
          userName: response.data[0][i].user_name,
          userCompanyName: response.data[0][i].company_name,
          createdAt: response.data[0][i].created_at,
        });
      }

      setBoardList(newBoardList);
    } catch (error) {
      console.log('error', error);
    }
  };

  useLayoutEffect(() => {
    fetchData(data);
  }, []);

  return (
    <>
      <DivTable sx={{ minWidth: 100 }} aria-label="simple table">
        <DivTableBody>
          {boardList.map((row) => (
            <DivTableRow key={row.id} hover>
              <DivTableCell component="th" scope="row">
                {row.name}
              </DivTableCell>
              <div
                style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', whiteSpace: 'nowrap' }}
              >
                <DivTableTitle>{row.title}</DivTableTitle>
                <DivTableContent>{row.content}</DivTableContent>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <DivTableCell style={{ width: '120px', justifyContent: 'flex-end' }}>{row.createdAt}</DivTableCell>
              </div>
            </DivTableRow>
          ))}
        </DivTableBody>
      </DivTable>
    </>
  );
}
